<script>
import axios from "axios";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      listDimensi: [],
      listKategori: [],
      kategori_selected: [],
      dimensi_selected: [],
      formData: {
        no_urut: "",
        pertanyaan: "",
        kategori: "",
        dimensi: "",
      },
    };
  },
  mounted() {
    this.getKategori();
    this.getDimensi();
    console.log('kategori :',this.kategori_selected);
  },
  methods: {
    // Tambah select baru
    addSelectKategori() {
      this.kategori_selected.push({ idkategori_survei: null, kategori_aspek: null })
    },

    // Hapus select berdasarkan index
    removeSelectKategori(index) {
      this.kategori_selected.splice(index, 1)
    },
    addSelectDimensi() {
      this.dimensi_selected.push({ iddimensi_survei: null, dimensi_aspek: null })
    },

    // Hapus select berdasarkan index
    removeSelectDimensi(index) {
      this.dimensi_selected.splice(index, 1)
    },
    getKategori() {
      const authToken = localStorage.access_token;
      axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/kategori-survei",
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        )
        .then((response) => {
          console.log("Response:", response.data);
          this.listKategori = response.data.data;
        })
        .catch((error) => {
          // Handle errors
          console.error("Error:", error.response.data);
        });
    },
    getDimensi(){
      const authToken = localStorage.access_token;
      axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/dimensi-survei",
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        )
        .then((response) => {
          console.log("Response:", response.data);
          this.listDimensi = response.data.data;
        })
        .catch((error) => {
          // Handle errors
          console.error("Error:", error.response.data);
        });
    },
    submitForm() {
      Swal.fire({
        title: "Loading...",
        html: "<i class='fa fa-spinner fa-spin'></i> ",
        showConfirmButton: false,
        allowOutsideClick: false
      });
      const authToken = localStorage.access_token;

      this.formData.kategori = [...new Set(this.kategori_selected.map(item => item.idkategori_survei))];
      this.formData.dimensi = [... new Set(this.dimensi_selected.map(item => item.iddimensi_survei))];

      let payload = { ...this.formData };
      axios
        .post(
          process.env.VUE_APP_BACKEND_URL_VERSION + "master/pertanyaan",
          payload,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          console.log("Response submit:", response.data);
          this.resetForm();
          Swal.fire({
            icon: "success",
            title: "Berhasil menambah pertanyaan",
            timer: 2000,
            showConfirmButton: false
          }).then((result) => {
            if (result.dismiss === Swal.DismissReason.timer) {
              this.$emit("refresh");
              this.$emit("close");
            }
          });
        })
        .catch((error) => {
          // Handle errors
          console.error("Error:", error.response.data);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error?.response?.data?.data,
            timer: 2000
          })
        });
    },
    resetForm() {
      this.formData.no_urut = "";
      this.formData.pertanyaan = "";
      this.formData.kategori = "";
      this.formData.dimensi = "";
    },
  },
};
</script>

<style scoped>
/* Add your custom styles here if needed */
</style>

<template>
  <div class="container">
    <form @submit.prevent="submitForm" class="needs-validation" novalidate>
      <div class="mb-3">
        <label for="nomor_urut" class="form-label">No Urut</label>
        <input
          v-model="formData.no_urut"
          type="integer"
          class="form-control"
          id="nomor_urut"
          required
        />
      </div>

      <div class="mb-3">
        <label for="pertanyaan" class="form-label">Pertanyaan</label>
        <textarea
          v-model="formData.pertanyaan"
          class="form-control"
          id="pertanyaan"
          required
        ></textarea>
      </div>

      <div class="mb-3">
        <label :for="'kategori-' + index" class="form-label">
          Kategori
        </label>

        <table class="table table-striped table-condensed">
          <tbody class="text-center">
            <tr class="mb-3" v-for="(kategori, index) in kategori_selected"
            :key="index">
              <td style="width: 10px;">
                <button
                  type="button"
                  class="btn btn-danger btn-sm"
                  @click="removeSelectKategori(index)"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </td>
              <td>
                <v-select
                  :id="'kategori-' + index"
                  class="style-chooser flex-grow-1"
                  :options="listKategori"
                  :clearable="false"
                  label="kategori_aspek"
                  v-model="kategori_selected[index]"
                  placeholder="Pilih kategori"
                />
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <div class="d-grid gap-2">
                <button
                  class="btn btn-success btn-sm"
                  type="button"
                  @click="addSelectKategori()"
                >
                  <i class="fa fa-plus me-3"></i> Tambah Kategori
                </button>
              </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mb-3">
        <label :for="'dimensi'" class="form-label">
          Dimensi
        </label>
        <table class="table table-striped table-condensed">
          <tbody class="text-center">
            <tr class="mb-3" v-for="(dimensi, index) in dimensi_selected"
            :key="index">
              <td style="width: 10px;">
                <button
                  type="button"
                  class="btn btn-danger btn-sm"
                  @click="removeSelectDimensi(index)"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </td>
              <td>
                <v-select
                  :id="'dimensi-' + index"
                  class="style-chooser flex-grow-1"
                  :options="listDimensi"
                  :clearable="false"
                  label="dimensi_aspek"
                  v-model="dimensi_selected[index]"
                  placeholder="Pilih dimensi"
                />
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <div class="d-grid gap-2">
                <button
                  class="btn btn-success btn-sm"
                  type="button"
                  @click="addSelectDimensi()"
                >
                  <i class="fa fa-plus me-3"></i> Tambah Dimensi
                </button>
              </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mb-3">
        <button type="submit" class="btn btn-primary">Submit</button>
      </div>
    </form>
  </div>
</template>
